<template>
    <ul>
        <li v-for="item in items.slice(0,3)" :key="item.Auteur+item.Titre+item.date">{{item.Auteur}}<template v-if="item.Auteur && item.Titre"> - </template>{{item.Titre}}</li>
    </ul>
</template>

<script>
export default {
    props: {
        'oma': {type: Object, required: true},
        'channel': {type: String, required: true},
    },
    data: () => ({
        itemsDirect: [], /* list of dict */
        itemsReplay: [],
		type: '',
    }),
    created: function () {
        const _this = this;
        this.oma.ows.handler(this.channel,     (data) => {_this.itemsDirect = _this.update(data)})
        this.oma.ows.handler('R'+this.channel, (data) => {_this.itemsReplay = _this.update(data)})
		// eslint-disable-next-line
		this.oma.player.ontype = (value => {
			this.type = value
		})
		this.type = this.oma.player.type
    },
    methods: {
        update: function (data) {
            var l = [];
            var newitem = null;
            for (var i in data) {
                if ('M' in data[i] || 'C' in data[i] ) { continue; }
                else if ('A' in data[i]) {
                    newitem = {Auteur: data[i]['A']};
                }
                else if ('T' in data[i]) {
                    if (newitem == null) {
                        newitem = {Auteur: ''};
                    }
                    newitem.Titre = data[i]['T'];
					newitem.date = Date.now()
                    l.push(newitem);
                    newitem = null;
                }
            }
            return l;
        },
    },
    computed: {
        items: function() {
            if (this.type == 'REPLAY')
                return this.itemsReplay
            else if (this.type == 'DIRECT' || this.type == 'NONE')
                return this.itemsDirect
            else
                return []
        },
    }
}
</script>

<style scoped>
    ul {
        margin: 5px;
		padding: 0;
    }
    ul li:first-child {
        list-style-type: circle;
    }
    li {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        list-style-position: inside;
    }
</style>
